import queryString from "query-string"

const assignCampaign = (campaigns, setValue) => {
  // On accepte les deux écritures du paramètre : CampaignId et campaignId
  const { CampaignId, campaignId } = queryString.parse(document.location.search)
  const campaignIdFromQuery = CampaignId || campaignId
  if (campaignIdFromQuery !== undefined) {
    // On cherche le campus et la date selon cet id
    const campaign = campaigns.find(el => el.Id === campaignIdFromQuery)
    if (campaign !== undefined) {
      setValue('lead.Campus__c', campaign.Campus__c)
      setValue('campaignId', campaign.Id)
      if (campaign.Campus__c === 'National') {
        setValue('campaignNational', true)
        setValue('lead.Campus__c', '')
      }
    }
  }
}

export { assignCampaign }